import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <div className="about-text text-center">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>

              {/* Cards Section */}
              <div className="row mt-5">
                {props.data && props.data.cards
                  ? props.data.cards.map((card, index) => (
                      <div className="col-12 col-sm-6 col-md-4 text-center px-3 mb-4" key={index}>
                        <img
                          src={card.image}
                          alt={card.title}
                          className="img-fluid mb-3 rounded shadow"
                          style={{
                            maxHeight: "200px",
                            objectFit: "cover",
                            width: "100%",
                          }}
                        />
                        <h4>{card.title}</h4>
                        <p>{card.description}</p>
                      </div>
                    ))
                  : "loading"}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
